/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const SERVICE_NAME = "InventorySummaryDetailPageService";
const log: any = LoggerModule.getInstance();

export class InventorySummaryDetailPageService {
  private static instance: InventorySummaryDetailPageService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): InventorySummaryDetailPageService {
    if (!InventorySummaryDetailPageService.instance) {
      InventorySummaryDetailPageService.instance = new InventorySummaryDetailPageService(props);
    }
    return InventorySummaryDetailPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    // Detail data
    compProps = await agent.getSummaryDetailProps({ ...args });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
